import { renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["data-variant", "data-size", "id"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        "data-slot": "item",
        "data-variant": $props.variant,
        "data-size": $props.size,
        id: $setup.buildId(),
        class: _normalizeClass($setup.cn($setup.itemVariants({ variant: $props.variant, size: $props.size, state: $props.state }), $setup.props.class))
    }, [
        (_ctx.$slots.header)
            ? (_openBlock(), _createBlock($setup["ItemHeader"], { key: 0 }, {
                default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "header")
                ]),
                _: 3 /* FORWARDED */
            }))
            : _createCommentVNode("v-if", true),
        _createElementVNode("div", {
            class: _normalizeClass(['flex items-center w-full min-w-0', $setup.rowVariantClass])
        }, [
            (_ctx.$slots.media)
                ? (_openBlock(), _createBlock($setup["ItemMedia"], {
                    key: 0,
                    variant: $props.mediaVariant
                }, {
                    default: _withCtx(() => [
                        _renderSlot(_ctx.$slots, "media")
                    ]),
                    _: 3 /* FORWARDED */
                }, 8 /* PROPS */, ["variant"]))
                : _createCommentVNode("v-if", true),
            ($props.title || $props.description || _ctx.$slots.default)
                ? (_openBlock(), _createBlock($setup["ItemContent"], { key: 1 }, {
                    default: _withCtx(() => [
                        ($props.title)
                            ? (_openBlock(), _createBlock($setup["ItemTitle"], { key: 0 }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString($props.title), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            }))
                            : _createCommentVNode("v-if", true),
                        ($props.description)
                            ? (_openBlock(), _createBlock($setup["ItemDescription"], { key: 1 }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString($props.description), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            }))
                            : _createCommentVNode("v-if", true),
                        _renderSlot(_ctx.$slots, "default")
                    ]),
                    _: 3 /* FORWARDED */
                }))
                : _createCommentVNode("v-if", true),
            (_ctx.$slots.actions)
                ? (_openBlock(), _createBlock($setup["ItemActions"], { key: 2 }, {
                    default: _withCtx(() => [
                        _renderSlot(_ctx.$slots, "actions")
                    ]),
                    _: 3 /* FORWARDED */
                }))
                : _createCommentVNode("v-if", true)
        ], 2 /* CLASS */),
        (_ctx.$slots.footer)
            ? (_openBlock(), _createBlock($setup["ItemFooter"], { key: 1 }, {
                default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "footer")
                ]),
                _: 3 /* FORWARDED */
            }))
            : _createCommentVNode("v-if", true)
    ], 10 /* CLASS, PROPS */, _hoisted_1));
}
